import { render, staticRenderFns } from "./AppCreateLinkContact.vue?vue&type=template&id=cf71ae34&scoped=true"
import script from "./AppCreateLinkContact.vue?vue&type=script&lang=js"
export * from "./AppCreateLinkContact.vue?vue&type=script&lang=js"
import style0 from "./AppCreateLinkContact.vue?vue&type=style&index=0&id=cf71ae34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf71ae34",
  null
  
)

export default component.exports